'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('journal-entries', {
      url: '/accounting/journal',
      template: '<journal-entries></journal-entries>'
    });
}



// WEBPACK FOOTER //
// ./client/app/accounting/journal-entries/journal-entries.routes.js